import React, { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import api, { mediaUrl } from "@/lib/api";

export default function ImageUpload({ value, onChange, testid, aspect = "aspect-[16/7]", label = "Upload image", endpoint = "/media/upload", maxMB = 5 }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > maxMB * 1024 * 1024) { toast.error(`Max file size is ${maxMB}MB`); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post(endpoint, fd);
      onChange(r.data.url);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally { setBusy(false); }
  };

  return (
    <div className={`relative ${aspect} rounded-xl overflow-hidden border border-dashed border-white/15 bg-black/30 group`}>
      {value && <img src={mediaUrl(value)} alt="" className="absolute inset-0 w-full h-full object-cover" />}
      <button type="button" onClick={() => ref.current?.click()} data-testid={testid}
        className={`absolute inset-0 flex flex-col items-center justify-center gap-1.5 text-xs font-semibold transition-colors ${value ? "bg-black/0 opacity-0 group-hover:opacity-100 group-hover:bg-black/60 text-white" : "text-white/50 hover:text-white"}`}>
        {busy ? <Loader2 className="animate-spin" size={20} /> : <ImagePlus size={20} />}
        {busy ? "Uploading…" : value ? "Change image" : label}
      </button>
      {value && !busy && (
        <button type="button" onClick={() => onChange("")} className="absolute top-2 right-2 p-1 rounded-md bg-black/70 text-white/70 hover:text-white" data-testid={`${testid}-clear`}><X size={14} /></button>
      )}
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} />
    </div>
  );
}
